var _circle, _rect, _rect2, _path, _polygon, _path2, _polygon2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8WearHighVisibilityJacket50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#1565c0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 2,
    x: 25,
    y: 31,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 3,
    x: 25,
    y: 35,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15,10h2v19h-4v-8C13,21,15,18,15,10z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "23,16.88 23,29 19,29 19,10 20,10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M33,10h-2v19h4v-8C35,21,33,18,33,10z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "25,16.88 25,29 29,29 29,10 28,10"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 2,
    x: 13,
    y: 31,
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 3,
    x: 13,
    y: 35,
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8WearHighVisibilityJacket50);
export default __webpack_public_path__ + "static/media/icons8-wear-high-visibility-jacket-50.5d468c78eeae85bb71ca321f93eb77e9.svg";
export { ForwardRef as ReactComponent };